/* eslint-disable react-hooks/exhaustive-deps */
import { DownloadFile } from '@tmov/design-system/icons';
import PDFMerger from 'pdf-merger-js';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';

import TipoDocumentoEnum from '../../../../../../../../../Enum/TipoDocumentoEnum';
import apiATS from '../../../../../../../../../services/apiATS';
import apiNetCore from '../../../../../../../../../services/apiNetCore';
import colors from '../../../../../../../../../styles/colors';
import { IconButton } from '../styles';

function DownloadDocumento({ documentos }) {
  const fetchPdf = async doc => {
    const { tipoDocumento, isMaxicon, link } = doc;

    if (tipoDocumento === TipoDocumentoEnum.OrdemDeCarregamento && isMaxicon) {
      return apiATS.get(link, { responseType: 'blob' });
    }
    return apiNetCore.get(link, { responseType: 'blob' });
  };

  const download = async doc => {
    const response = await fetchPdf(doc);

    if (response.status === 200) {
      const file = new Blob([response.data], {
        type: response.data.type ?? 'application/pdf',
      });
      const fileURL = URL.createObjectURL(file);
      window.open(fileURL);
    }
  };
  const downloadMultiplos = async docs => {
    const merger = new PDFMerger();

    const fetchAllDocs = docs.map(async doc => {
      try {
        const { data: pdfFile } = await fetchPdf(doc);
        await merger.add(pdfFile);
        return Promise.resolve();
      } catch (error) {
        return Promise.reject();
      }
    });

    await Promise.all(fetchAllDocs);

    const mergedPdf = await merger.saveAsBlob();
    const url = URL.createObjectURL(mergedPdf);
    window.open(url);
  };

  const handleDownload = useCallback(() => {
    if (documentos.length > 1) {
      downloadMultiplos(documentos);
    } else {
      download(documentos[0]);
    }
  }, [documentos]);

  return (
    <>
      <IconButton
        data-testid="icon-button-download"
        type="button"
        onClick={() => handleDownload()}
      >
        <DownloadFile color={colors.tmov_green} aria-label="download" />
      </IconButton>
    </>
  );
}

const documento = PropTypes.shape({
  id: PropTypes.string,
  tipoDocumentoDescricao: PropTypes.string,
  tipoDocumento: PropTypes.number.isRequired,
  dataCriacao: PropTypes.string,
  isMaxicon: PropTypes.bool,
  link: PropTypes.string,
  idUsuario: PropTypes.number,
  idUsuarioShipper: PropTypes.number,
});

DownloadDocumento.propTypes = {
  documentos: PropTypes.arrayOf(documento).isRequired,
};

DownloadDocumento.defaultProps = {};

export default DownloadDocumento;
